import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'
import {
  ShowPageContainer,
  ShowPageItemContainer,
} from 'src/components/PageLayout/ShowPage'

export const StyledModelId = styled.div`
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const RESULT_TAB_GRID_COLUMNS =
  'min-content 1fr repeat(4, auto) 186px repeat(2, min-content)'

export const LinkagesMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${palette.neutral[100]};
  border-radius: 16px;
  width: 400px;
`
export const LinkagesMenuBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ControlsShowPageContainer = styled(ShowPageContainer)`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
`

export const ControlsShowPageLayout = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;

  > *:first-child {
    flex: 1 1 0%;
    min-width: 0;
  }
`

export const ControlsShowPageItemContainer = styled(ShowPageItemContainer)`
  height: 100%;
  gap: 24px;
`
